// Per-country SEO landing pages for the free tax calculator.
// Each renders the same calculator but pre-selects a region with unique SEO copy.

export const CALCULATOR_PAGES = [
  {
    path: '/tools/1099-tax-calculator',
    regionKey: 'US',
    name: 'United States (1099)',
    flag: '🇺🇸',
    badge: 'Free 2026 Estimator',
    h1: '1099 Self-Employment Tax Calculator',
    intro: 'Estimate your US 1099 taxes — self-employment tax (15.3%), federal income tax and your quarterly payment.',
    seoTitle: '1099 Tax Calculator 2026 — Free, With Deductions | MoneyFeed',
    seoDescription: '1099 tax calculator: see exactly what you owe on 1099 income in seconds — federal self-employment tax (15.3%), income tax and deductions included. Free.',
  },
  {
    path: '/tools/uk-self-assessment-tax-calculator',
    regionKey: 'UK',
    name: 'United Kingdom',
    flag: '🇬🇧',
    badge: 'Free UK Estimator',
    h1: 'UK Self Assessment Tax Calculator',
    intro: 'Estimate your UK self-employed tax — income tax bands plus Class 4 National Insurance — for your Self Assessment.',
    seoTitle: 'Free UK Self Assessment Tax Calculator 2025/26 | MoneyFeed',
    seoDescription: 'Free UK Self Assessment tax calculator (2025/26) for freelancers and sole traders. Estimate your income tax and Class 4 National Insurance in seconds',
  },
  {
    path: '/tools/canada-self-employed-tax-calculator',
    regionKey: 'CA',
    name: 'Canada',
    flag: '🇨🇦',
    badge: 'Free Canada Estimator',
    h1: 'Canada Self-Employed Tax Calculator',
    intro: 'Estimate your Canadian self-employed taxes — federal income tax, CPP contributions and provincial tax (T2125).',
    seoTitle: 'Self-Employed Tax Calculator Canada 2026 | MoneyFeed',
    seoDescription: 'Calculate your Canadian self-employment taxes — CPP contributions plus federal and provincial income tax. Free, updated for 2026.',
  },
  {
    path: '/tools/germany-self-employed-tax-calculator',
    regionKey: 'DE',
    name: 'Germany',
    flag: '🇩🇪',
    badge: 'Free 2026 Germany Estimator',
    h1: 'Germany Freelancer & Self-Employed Tax Calculator',
    intro: 'Estimate your German taxes — income tax (Einkommensteuer, 2026 §32a), health & long-term care contributions, plus a 19% VAT (Umsatzsteuer) summary with the Kleinunternehmer limit.',
    seoTitle: 'Germany Self-Employed Tax Calculator 2026 | MoneyFeed',
    seoDescription: 'Free Germany self-employed tax calculator for freelancers (Freiberufler) — estimate Einkommensteuer, health & care insurance and 19% VAT for 2026 in seconds.',
  },
  {
    path: '/tools/spain-autonomo-tax-calculator',
    regionKey: 'ES',
    name: 'Spain (Autónomo)',
    flag: '🇪🇸',
    badge: 'Free 2026 Spain Estimator',
    h1: 'Spain Autónomo Tax Calculator',
    intro: 'Estimate your Spanish autónomo taxes — IRPF income tax (2026 brackets), your monthly RETA social-security contribution, and a 21% IVA summary.',
    seoTitle: 'Spain Autónomo Tax Calculator 2026 — IRPF & IVA',
    seoDescription: 'Free 2026 Spain autónomo tax calculator. Estimate your IRPF income tax, RETA social-security quota and 21% IVA — for freelancers and self-employed',
  },
  {
    path: '/tools/france-auto-entrepreneur-tax-calculator',
    regionKey: 'FR',
    name: 'France (Micro)',
    flag: '🇫🇷',
    badge: 'Free 2026 France Estimator',
    h1: 'France Auto-Entrepreneur Tax Calculator',
    intro: 'Estimate your French micro-entrepreneur charges — URSSAF social contributions on turnover, income tax under the 2026 barème, and your TVA franchise threshold.',
    seoTitle: 'France Auto-Entrepreneur Tax Calculator 2026',
    seoDescription: 'Free 2026 micro-entrepreneur tax calculator for France. Estimate your URSSAF social contributions, income tax (barème) and TVA thresholds by activity',
  },
  {
    path: '/tools/australia-sole-trader-tax-calculator',
    regionKey: 'AU',
    name: 'Australia',
    flag: '🇦🇺',
    badge: 'Free 2025-26 Australia Estimator',
    h1: 'Australia Sole Trader Tax Calculator',
    intro: 'Estimate your Australian sole-trader tax — resident income tax (2025-26 ATO brackets), the 2% Medicare levy, and your GST registration threshold.',
    seoTitle: 'Australia Sole Trader Tax Calculator 2025-26 | MoneyFeed',
    seoDescription: 'Free 2025-26 sole trader tax calculator for Australia. Estimate your income tax (ATO brackets), 2% Medicare levy and check the A$75,000 GST threshold',
  },
  {
    path: '/tools/new-zealand-sole-trader-tax-calculator',
    regionKey: 'NZ',
    name: 'New Zealand',
    flag: '🇳🇿',
    badge: 'Free 2025-26 New Zealand Estimator',
    h1: 'New Zealand Sole Trader Tax Calculator',
    intro: "Estimate your New Zealand sole-trader tax — IRD income tax (2025-26 brackets), the ACC earners' levy, and your GST registration threshold.",
    seoTitle: 'New Zealand Sole Trader Tax Calculator 2025-26',
    seoDescription: "Free 2025-26 sole trader tax calculator for New Zealand. Estimate your IRD income tax, ACC earners' levy and check the NZ$60,000 GST threshold — no sign-up.",
  },
  {
    path: '/tools/uae-vat-calculator',    regionKey: 'UAE',
    name: 'UAE (VAT)',
    flag: '🇦🇪',
    badge: 'Free UAE VAT Estimator',
    h1: 'UAE VAT Calculator for Freelancers',
    intro: 'Estimate your net UAE VAT (5%) — VAT collected on sales minus VAT paid on expenses — and see if you must register with the FTA.',
    seoTitle: 'UAE VAT Calculator for Freelancers (5%) | MoneyFeed',
    seoDescription: 'Free UAE VAT calculator. Work out your net VAT payable at 5% and check the AED 375,000 FTA registration threshold — for freelancers and small businesses.',
  },
  {
    path: '/tools/saudi-arabia-vat-calculator',
    regionKey: 'KSA',
    name: 'Saudi Arabia (VAT)',
    flag: '🇸🇦',
    badge: 'Free Saudi VAT Estimator',
    h1: 'Saudi Arabia VAT Calculator',
    intro: 'Estimate your net Saudi VAT (15%) — VAT collected on sales minus VAT paid on expenses — and check the ZATCA registration threshold.',
    seoTitle: 'Saudi Arabia VAT Calculator (15%) — ZATCA | MoneyFeed',
    seoDescription: 'Free Saudi Arabia VAT calculator. Estimate your net VAT payable at 15% and check the SAR 375,000 ZATCA registration threshold — for freelancers and businesses.',
  },
];

export const getCalculatorPage = (regionKey) =>
  CALCULATOR_PAGES.find((p) => p.regionKey === regionKey) || CALCULATOR_PAGES[0];
